// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { createContext, useContext } from 'react';

export type PlacePrediction = Pick<
  google.maps.places.AutocompletePrediction,
  'place_id' | 'description'
>;

export interface GooglePlacesData {
  isReady: boolean;
  getDetails: (
    placeId: string
  ) => Promise<google.maps.places.PlaceResult | null>;
  getPredictions: (input: string) => Promise<PlacePrediction[]>;
  geocodeAddress: (
    address: string,
    componentRestrictions?: google.maps.GeocoderComponentRestrictions
  ) => Promise<google.maps.GeocoderResult | null>;
}

export const GooglePlacesContext = createContext<GooglePlacesData | undefined>(
  undefined
);

/**
 * A React hook that provides access to the Google Places context.
 */
export function useGooglePlaces() {
  const context = useContext(GooglePlacesContext);

  if (context === undefined) {
    const error =
      'useGooglePlaces must be used within a GooglePlacesContext provider';

    throw new Error(error);
  }

  return context;
}
